export default "__VITE_ASSET__9af251bd__"